import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IDepsMobile, TPropsMobile } from '../models';
import { Text as Component } from '../text';
import styles from '../styles/styles.css';
import { fontViewsMobile } from '../config';

export const TextMobile = createWidget<IDepsMobile, TPropsMobile>({
    styles,
    fontViews: fontViewsMobile,
})(Component);
